'use client';

// LoadingLottie.tsx
import React from 'react';
import LottieAnimation, { preloadLottie } from './LottieAnimation';

// Also preloaded from app/layout.tsx for the SplashScreen; change both together.
const LOADING_LOTTIE_PATH = '/loading-lottie-A.json';

// Start loading as soon as the bundle runs rather than when the first loader
// mounts, so the first one (the SplashScreen, the SPA shell's fallback) is
// ready sooner and every later one draws immediately.
if (typeof window !== 'undefined') {
  preloadLottie(LOADING_LOTTIE_PATH);
}

interface LoadingLottieProps {
  minHeight?: string;
  onReady?: () => void;
}

const LoadingLottie: React.FC<LoadingLottieProps> = ({ minHeight = 'min-h-[100vh]', onReady }) => (
  <div className={`${minHeight} w-full flex items-center justify-center`}>
    <div className="w-20 h-20 md:w-28 md:h-28">
      <LottieAnimation
        path={LOADING_LOTTIE_PATH}
        width="100%"
        height="100%"
        onReady={onReady}
      />
    </div>
  </div>
);

export default LoadingLottie;
